import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'

import { useFormik } from 'formik'
import { wageringSelector } from '@/state/wagering-contribution/slices/index.slices'
import {
  WageringCategory,
  WageringCategorySaveItem,
} from '@/state/wagering-contribution/models'

import { useWageringActions } from './use-wagering-actions.hook'

export const useWageringCategoryForm = () => {
  const { t } = useTranslation()

  const {
    wageringCategory,
    currentWageringCategory,
    categoriesList,
    wageringContributionId,
  } = useSelector(wageringSelector)

  const { saveWageringCategory, setCurrentWageringCategory } =
    useWageringActions()

  const handleSaveWageringContribution = () => {
    let savedWageringItemsList: WageringCategorySaveItem[] = []

    if (currentWageringCategory) {
      wageringCategory
        .filter(
          (item: WageringCategory) =>
            item.id !== Number(currentWageringCategory.id),
        )
        .forEach((wagering: WageringCategory) => {
          const wageringItem: WageringCategorySaveItem = {
            code: wagering.code,
            percentage: wagering.percentage,
            isBlocked: wagering.isBlocked,
            type: wagering.type,
          }
          savedWageringItemsList.push(wageringItem)
        })
    } else {
      wageringCategory.forEach((wagering: WageringCategory) => {
        const wageringItem: WageringCategorySaveItem = {
          code: wagering.code,
          percentage: wagering.percentage,
          isBlocked: wagering.isBlocked,
          type: wagering.type,
        }
        savedWageringItemsList.push(wageringItem)
      })
    }

    savedWageringItemsList.push({
      code: formikWageringCategory.values.code.id,
      percentage: Number(formikWageringCategory.values.percentage),
      isBlocked: formikWageringCategory.values.isBlocked,
      type: 1,
    })

    saveWageringCategory({
      _id: wageringContributionId,
      name: 'Default Wagering Contribution',
      contributions: savedWageringItemsList,
    })

    setCurrentWageringCategory()
  }

  const initialValuesWagering = {
    code: {
      id: currentWageringCategory?.code,
      name: currentWageringCategory?.Name,
    },
    percentage: currentWageringCategory?.percentage || '',
    isBlocked: currentWageringCategory?.isBlocked || false,
  }

  const validationSchemaWagering = Yup.object().shape({
    code: Yup.object().nullable(false).required(t('error.requiredField')),
    percentage: Yup.number().required(t('error.requiredField')),
  })

  const formikWageringCategory = useFormik({
    initialValues: initialValuesWagering,
    validationSchema: validationSchemaWagering,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  return {
    handleSaveWageringContribution,
    setCurrentWageringCategory,
    wageringCategory,
    categoriesList,
    formikWageringCategory,
    currentWageringCategory,
  }
}
